import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SvgIconModule } from '../svg-icon';
import { SimpleSelectModule } from '../simple-select/simple-select.module';
import { TooltipInputModule } from '../tooltip-input/tooltip-input.module';

import { VoucherManagerComponent } from './voucher-manager.component';
import { ListVoucherModule } from '../list-voucher/list-voucher.module';

@NgModule({
    declarations: [VoucherManagerComponent],
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
        SimpleSelectModule,
        TooltipInputModule,
        ListVoucherModule
    ],
    exports: [
        VoucherManagerComponent
    ]
})
export class VoucherManagerModule { }
